/**
 * FieldDropZone — the "＋ Drop field here" target at the bottom of a fields
 * section.
 *
 * It only materialises while a field is actually being dragged (either a type
 * from the sidebar library or an existing field being moved), so the canvas
 * stays clean at rest. Dropping here appends to the end of the section;
 * dropping onto an existing field inserts before that field instead.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDroppable, useDndContext } from '@dnd-kit/core';
import { RiAddLine } from 'react-icons/ri';

// True when the thing being dragged is a field (library tile or existing row).
export function isFieldDrag(active) {
  if (!active) return false;
  if (typeof active.id === 'string' && active.id.startsWith('sidebar-field-')) return true;
  return active.data?.current?.type === 'field';
}

export default function FieldDropZone({ sectionId, alwaysVisible = false }) {
  const { t } = useTranslation();
  const { active } = useDndContext();
  const { setNodeRef, isOver } = useDroppable({
    id: `dropzone-${sectionId}`,
    data: { type: 'dropzone', sectionId },
  });

  const dragging = isFieldDrag(active);
  if (!dragging && !alwaysVisible) return null;

  return (
    <div
      ref={setNodeRef}
      className={`fmx-dropzone ${isOver ? 'is-over' : ''} ${dragging ? 'is-armed' : ''}`}
      aria-hidden="true"
    >
      <span className="fmx-dropzone__inner">
        <RiAddLine />
        <span>{t('fieldsManager.dropzone.dropHere')}</span>
      </span>
    </div>
  );
}
